import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import DropDownMenu from '../../DropDownMenu.jsx';

const messages = defineMessages({
    title: {
        id: 'grid.menu.title',
        defaultMessage: 'Меню событий'
    },
    collapseAllEvents: {
        id: 'grid.menu.collapse_all_events',
        defaultMessage: 'Свернуть все события'
    },
    expandAllEvents: {
        id: 'grid.menu.expand_all_events',
        defaultMessage: 'Развернуть все события'
    },
    collapseAllGroups: {
        id: 'grid.menu.collapse_all_groups',
        defaultMessage: 'Свернуть все доп. ставки'
    },
    expandAllGroups: {
        id: 'grid.menu.expand_all_groups',
        defaultMessage: 'Развернуть все доп. ставки'
    },
    displayLineNumbers: {
        id: 'grid.menu.display_line_numbers',
        defaultMessage: 'Отображать номера событий'
    },
    hideLineNumbers: {
        id: 'grid.menu.hide_line_numbers',
        defaultMessage: 'Скрыть номера событий'
    }
});

function _localizedLink(message, onClick) {
    return (
        <FormattedMessage {...message}>
            {(localizedMessage) =>
                <a href="#" target="_blank" className="dropdown--menu__link" onClick={onClick}>
                    {localizedMessage}
                </a>}
        </FormattedMessage>
    );
}

export default class LiveMenu extends React.Component {
    static propTypes = {
        onCollapseAllMatchesClick: React.PropTypes.func.isRequired,
        onExpandAllMatchesClick: React.PropTypes.func.isRequired,
        onCollapseAllGroupsClick: React.PropTypes.func.isRequired,
        onExpandAllGroupsClick: React.PropTypes.func.isRequired,
        onDisplayLineNumbersClick: React.PropTypes.func.isRequired,
        onHideLineNumbersClick: React.PropTypes.func.isRequired,
        onClosing: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const cssClass = 'dropdown--menu-live-grid';

        const {
            onCollapseAllMatchesClick,
            onExpandAllMatchesClick,
            onCollapseAllGroupsClick,
            onExpandAllGroupsClick,
            onDisplayLineNumbersClick,
            onHideLineNumbersClick,
            onClosing
            } = this.props;

        const elements = [
            {content: _localizedLink(messages.collapseAllEvents, onCollapseAllMatchesClick)},
            {content: _localizedLink(messages.expandAllEvents, onExpandAllMatchesClick)},
            {content: _localizedLink(messages.collapseAllGroups, onCollapseAllGroupsClick)},
            {content: _localizedLink(messages.expandAllGroups, onExpandAllGroupsClick)},
            {content: _localizedLink(messages.displayLineNumbers, onDisplayLineNumbersClick)},
            {content: _localizedLink(messages.hideLineNumbers, onHideLineNumbersClick)}
        ];

        const title = (<FormattedMessage {...messages.title}/>);

        return (
            <DropDownMenu cssClass={cssClass}
                          title={title}
                          elements={elements}
                          onClosing={onClosing}
                />
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/LiveMenu.jsx